import React, { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { isVisible } from '@atlas/core';
import { Outcome, SettledOutcome } from '@atlas/ui';

import { sportService } from 'common/constants';
import eventShape from 'common/PropTypes/eventShape';
import marketShape from 'common/PropTypes/marketShape';
import marketTypeShape from 'common/PropTypes/marketTypeShape';
import outcomeShape from 'common/PropTypes/outcomeShape';

const OutcomeCol = ({
  className,
  customName,
  dataTestId,
  dataTestItemId,
  disabled = false,
  event,
  isFake,
  market,
  marketType: { betGroups, id: marketTypeId },
  outcome,
  outcome: { name, odds, settlementStatus, status },
  suspended,
}) => {
  const outcomeName = customName || name;
  const visible = disabled || isVisible(event) || isVisible(market) || isVisible(outcome);

  const clickHandler = useCallback(
    e => {
      if (suspended) return;

      e.eventId = event.id;
      e.marketTypeId = marketTypeId;
      e.marketId = market.id;
      e.outcomeId = outcome.id;
      e.betGroups = betGroups;
    },
    [suspended, event.id, marketTypeId, market.id, outcome.id, betGroups],
  );

  if (event.sportService !== sportService.ARCHIVED && !visible) {
    return null;
  }

  if (event.sportService === sportService.ARCHIVED) {
    const settledOutcomeClass = settlementStatus && settlementStatus.toLowerCase();
    const settledOutcomeClassName = cx(className, { [settledOutcomeClass]: settledOutcomeClass });

    if (!isFake) {
      return (
        <SettledOutcome
          className={settledOutcomeClassName}
          key={outcome.id}
          name={name}
          settlementStatus={settlementStatus}
        />
      );
    }
  }

  return (
    <>
      {isFake && <span className="outcome-fake">{name}</span>}
      <Outcome
        className={className}
        dataTestId={dataTestId}
        dataTestItemId={dataTestItemId}
        id={outcome.id}
        key={outcome.id}
        name={outcomeName}
        odds={odds}
        onClick={clickHandler}
        outcome={outcome}
        status={status}
        suspended={suspended}
      />
    </>
  );
};

OutcomeCol.propTypes = {
  disabled: PropTypes.bool,
  event: eventShape.isRequired,
  market: marketShape.isRequired,
  marketType: marketTypeShape.isRequired,
  outcome: outcomeShape.isRequired,
};

export default OutcomeCol;
